<template>
  <div>
    <div class="container-buttons">
      <router-link to="/cadastrar-lead">
        <button class="btn-custom btn-cobranca mb-3">
          <i class="fa fa-plus"></i> Cadastrar Lead
        </button>
      </router-link>
    </div>
    <div class="container_filtro">
      <div class="form-group">
        <label for="exampleFormControlTextarea2">Filtrar Origem</label>
        <select @change="onChangeStatusOrigin" class="form-control input i-width" required>
          <option value="all" selected>Todos</option>
          <option value="dashboard">Plataforma Interno</option>
          <option value="seller">Plataforma Externo</option>
          <option value="website">Site</option>
        </select>
      </div>
      <div class="form-group">
        <label for="exampleFormControlTextarea1">Filtrar Leads</label>
        <select @change="onChangeStatus" class="form-control input i-width" required>
          <option value="all" >Todos</option>
          <option value="pending" selected>Pendente</option>
          <option value="accepted">Aceito</option>
          <option value="rejected">Recusado</option>
        </select>
      </div>
    </div>
    <card title="Todos os Leads" subTitle="listagem de leads">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>ID</th>
            <th>Nome</th>
            <th>Nome Vendedor</th>
            <th>Telefone</th>
            <th>Cidade</th>
            <th>Data</th>
            <th>Status</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="lead in leads" :key="lead.id">
              <td>{{ lead.id }}</td>
              <td>{{ lead.name }}</td>
              <td>{{ formatSeller(lead.seller) }}</td>
              <td>{{ lead.phone }}</td>
              <td>{{ lead.city }}</td>
              <td>{{ formatDate(new Date(lead.createdAt)) }}</td>
              <td>{{ parseStatus(lead.status) }}</td>
              <td>
                <router-link :to="`/leads/${lead.id}`">
                  <p-button type="success" outline icon title="Visualizar Lead">
                    <i class="fa fa-eye"></i>
                  </p-button>
                </router-link>
                <p-button
                  v-if="userRole === 'admin'"
                  @click.prevent.native="deleteLead(lead.id)"
                  type="danger"
                  outline
                  icon
                  title="Apagar lead"
                >
                  <i class="fa fa-ban btn-delete"></i>
                </p-button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { formatDistance } from "date-fns";
import pt from "date-fns/locale/pt-BR";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    leads() {
      return this.$store.getters.leads;
    },
    pagination() {
      return this.$store.getters.leadsPagination;
    },
    userRole() {
      return this.$store.getters.user.role;
    },
    field() {
      return this.$store.getters.leadFields;
    },
  },
  data() {
    return {
      filters: {
        status: ['pending'],
        origin: [],
      },
    };
  },
  methods: {
    ...mapActions(["fetchLeads", "removeLead", "fetchLeadFields"]),
    async onChangeStatus(e) {
      switch (e.target.value) {
        case 'all':
          this.filters.status = [];
          break;
        case 'pending':
          this.filters.status = ['pending'];
          break;
        case 'rejected':
          this.filters.status = ['client_rejected', 'server_rejected'];
          break;
        case 'accepted':
          this.filters.status = ['accepted'];
          break;
      }
      await this.fetchLeads({
        currentPage: 1,
        status: this.filters.status.length > 0 ? this.filters.status : undefined,
        origin: this.filters.origin.length > 0 ? this.filters.origin : undefined,
      });
    },
    async onChangeStatusOrigin(e) {
      switch (e.target.value) {
        case 'all':
          this.filters.origin = [];
          break;
        case 'dashboard':
          this.filters.origin = ['dashboard'];
          break;
        case 'website':
          this.filters.origin = ['website'];
          break;
        case 'seller':
          this.filters.origin = ['seller'];
          break;
      }
      await this.fetchLeads({
        currentPage: 1,
        status: this.filters.status.length > 0 ? this.filters.status : undefined,
        origin: this.filters.origin.length > 0 ? this.filters.origin : undefined,
      });
    },
    formatSeller(id) {
      if (Array.isArray(this.field.sellers)) {
        const seller = this.field.sellers.find(s => s.id === id)
        if (seller) {
          return seller.name;
        }
      }
      return 'N/D';
    },
    formatDate(date) {
      return formatDistance(date, new Date(), {
        locale: pt,
        addSuffix: true
      });
    },
    parseStatus(status) {
      switch (status) {
        case "pending":
          return "pendente";
        case "accepted":
          return "aceito";
        case "client_rejected":
          return "cliente recusou";
        case "server_rejected":
          return "empresa recusou";
        default:
          return "pendente";
      }
    },
    async updatePagination({ currentPage }) {
      await this.fetchLeads({
        currentPage,
        status: this.filters.status.length > 0 ? this.filters.status : undefined,
        origin: this.filters.origin.length > 0 ? this.filters.origin : undefined,
      });
    },
    async deleteLead(id) {
      const result = await Swal.fire({
        title: "Atenção!",
        text: "Esta ação irá apagar o lead, deseja prosseguir?",
        icon: "warning",
        focusConfirm: false,
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#9dcf6b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim",
        cancelButtonText: "Não"
      });

      if (result.isConfirmed) {
        try {
          await this.removeLead({ id });
          Swal.fire({
            title: "Sucesso!",
            text: "Lead apagado com sucesso",
            icon: "success"
          });
        } catch (e) {
          Swal.fire({
            title: "Ops!",
            text: "Não foi possível apagar o lead",
            icon: "error"
          });
        }
      }
    }
  },
  async mounted() {
    try {
      await Promise.all([
        this.fetchLeads({
          currentPage: 1,
          status: this.filters.status.length > 0 ? this.filters.status : undefined,
          origin: this.filters.origin.length > 0 ? this.filters.origin : undefined,
        }),
        this.fetchLeadFields(),
      ]);
    } catch (err) {
      Swal.fire("Ops!", "Não foi possível carregar os leads", "error");
    }
  }
};
</script>

<style lang="scss" scoped >
.container_filtro {
  display: flex;
  justify-content: flex-end;
}
.container_filtro select {
  width: 15vw;
}
.container_filtro div:first-child {
  margin-right: 10px;
}
.container-buttons {
  display: flex;
  justify-content: space-between;

  a {
    cursor: pointer;
  }
}
i.btn-config {
  font-size: 40px;
}
.btn-custom {
  color: #f4f3ef;
  border: none;
  border-radius: 7px;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  padding: 13px 20px;
  transition: all 0.5s;

  &.btn-cobranca {
    background: #9dcf6b;

    &:hover {
      background: #82ac58;
    }
  }
}

.btn-outline-success {
  border-color: #9dcf6b;
  color: #9dcf6b;

  &:hover {
    background: #9dcf6b;
    border-color: #9dcf6b;
  }
}
</style>
